module.exports = __webpack_public_path__ + "img/P150T_weapon_152.7d74b8f2.png";